import { Clickable, H3, Markdown, PortableText, Span } from '@ahmdigital/ui';
import { Fragment } from 'react';
import { isArray, isUndefined, map } from 'lodash/fp';

import styles from './styles.module.sass';

// @ts-expect-error - Automatic, Please fix when editing this file
const wrapDescription = (description) =>
  isArray(description) ? <PortableText renderInline source={description} /> : <Markdown>{description}</Markdown>;

export type TermsAndConditionsProps = {
  terms:
    | {
        cta?: {
          icon: string;
          title: string;
          url: string;
        };
        descriptionRaw?: string | unknown[];
        footnote?: {
          linkId: string;
          reference: string;
        };
        title?: string | null;
      }[]
    | undefined;
};

const TermsAndConditions = ({ terms }: TermsAndConditionsProps) => (
  <>
    {map(({ title, descriptionRaw, footnote, cta }) => {
      const hasCta = !isUndefined(cta);

      return (
        <Fragment key={title}>
          {title && (
            <H3 looksLike="small" variant="marginBottomSpacer11">
              {title}
            </H3>
          )}
          <Span looksLike="p" variant={hasCta ? 'marginBottomSpacer10' : 'marginBottomSpacer9'}>
            <Span looksLike="small" variant={hasCta ? 'marginBottomSpacer10' : 'marginBottomSpacer9'}>
              {footnote && (
                <Span id={footnote.linkId} className={styles.footnotePrefix}>
                  {footnote.reference}
                </Span>
              )}

              {wrapDescription(descriptionRaw)}
            </Span>
          </Span>
          {hasCta && (
            // @ts-expect-error [🤖 PLEASE FIX 🤖]: Type 'string' is not assignable to type '"time" | "list" | "search" | "phone-circle" | "document" | "ambulance-services" | "ambulance" | "app-chevron-down" | "app-chevron-left" | "app-chevron-right" | "app-chevron-up" | ... 93 more ... | "youtube"'.
            <Clickable icon={{ name: cta.icon, size: 'small' }} to={cta.url} variant="marginBottomSpacer9">
              {cta.title}
            </Clickable>
          )}
        </Fragment>
      );
    }, terms)}
  </>
);

export default TermsAndConditions;
